import { render, staticRenderFns } from "./DetailsEvaluation.vue?vue&type=template&id=0563d18a&scoped=true&"
import script from "./DetailsEvaluation.vue?vue&type=script&lang=js&"
export * from "./DetailsEvaluation.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/detailsEvaluation.css?vue&type=style&index=0&id=0563d18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563d18a",
  null
  
)

export default component.exports